import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Returns `[debounced, flush]` where `debounced` updates after `delay` ms of stability,
 * and `flush()` sets `debounced` to the latest `value` immediately (e.g. "Search now").
 */
export function useDebouncedValue(value, delay = 350) {
  const [debounced, setDebounced] = useState(value);
  const valueRef = useRef(value);
  valueRef.current = value;

  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  const flush = useCallback(() => {
    setDebounced(valueRef.current);
  }, []);

  return [debounced, flush];
}
